import { Photo } from '@mui/icons-material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import {
  EmployeePictureEditMode,
  useEmployeeProfileForPictureEdit,
} from '~/components/Dialogs/UserProfilePictureDialog/useEmployeeProfileForPictureEdit';
import { UserProfilePictureDialogContent } from '~/components/Dialogs/UserProfilePictureDialog/UserProfilePictureDialogContent';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

type PropsType = AccountManagementMenu_OnUpdateLegacy & {
  employeeId?: number;
  open: boolean;
  onClose: () => void;
};

export const UserProfilePictureDialog = (props: PropsType) => {
  const { open, onClose, onUpdateLegacy, employeeId } = props;
  const { t } = useTranslation();

  const { pictureEditMode, employeeProfile, isLoading } =
    useEmployeeProfileForPictureEdit({ employeeId });

  const getTitleWithEmployeeName = useCallback(
    (title) =>
      !!employeeProfile && pictureEditMode === EmployeePictureEditMode.Selected
        ? `${title} - ${employeeProfile.firstName} ${employeeProfile.lastName}`
        : title,
    [pictureEditMode, employeeProfile],
  );

  const onSubmitSuccess = useCallback(() => {
    if (!!onUpdateLegacy) {
      onUpdateLegacy(['changeUserProfilePicture']);
    }
    onClose();
  }, [onUpdateLegacy, onClose]);

  return (
    <DraggableDialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'md'}
    >
      <SolaForceDialogTitle onClose={onClose} icon={<Photo />}>
        {getTitleWithEmployeeName(t('laPicture'))}
      </SolaForceDialogTitle>
      {isLoading && <LoadingView />}
      {open && !isLoading && (
        <UserProfilePictureDialogContent
          employeeProfile={employeeProfile}
          onClose={onClose}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
    </DraggableDialog>
  );
};
